import React, { useState } from 'react'
import { Checkbox, Tabs } from "antd"
import pluralize from 'pluralize'
import { useHistory, useParams } from 'react-router-dom'
import Select from 'react-select'
import Createable from 'react-select/creatable'

import Modal from "../resusable/modal"
import Receive from '../resusable/receive'
import NewInventoryItem from './newinventoryitem'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

const { TabPane } = Tabs

const SingleItemRequest = ({ path = '/app/store', onPerform }) => {
    const [request, setRequest] = useState([])
    const [single, setSingle] = useState()
    const [quantity, setQuantity] = useState(0)

    const [visible, toggle] = useToggle(true)

    const { id, rq } = useParams()

    const history = useHistory()

    const [{ loading, error }, viewRequest] = usePet('viewRequest', {
        id: rq
    }, { notify: true, callback: ({ data }) => setRequest(data) })

    const onComplete = ({ }, notif, ops) => {
        notif('Items have been issued', ops('success'))
        viewRequest()
    }

    const [{ loading: issLoading }, issueRequests] = usePet('issueRequests', {
        parent: rq,
        reqId: single,
        quantity
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Issuing items...' } })

    const onDComplete = ({ }, notif, ops) => {
        notif('Request has been discarded', ops('success'))
        viewRequest()
    }

    const [{ loading: discLoading }, discardRequest] = usePet('discardRequest', {
        parent: rq,
        reqId: single
    }, { notify: true, callback: onDComplete, manual: true, load: { msg: 'Discarding request...' } })
    
    const close = () => {
        toggle()
        onPerform()
        setTimeout(() => history.push(`${path}/requests/${id}`), 300)
    }

    return (
        <Modal
            h="h-auto"
            w="w-4/5 md:w-3/5 xl:w-2/5 mt-5"
            align="items-start"
            title="Request"
            toggle={close}
            visible={visible}>
            <p className="text-gray-500 text-xs italic">Requested by {request?.requestedBy?.name} on { stringifyDate(request?.date) }</p>
            <Receive
                error={error}
                loading={loading}
                progress>
                {
                    request?.requests?.length > 0 ?
                        <table className="table-auto w-full">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2 pl-4 text-center">
                                        <div className="font-semibold">No.</div>
                                    </th>
                                    <th className="p-2 pl-4 text-left">
                                        <div className="font-semibold">Item</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">Requested</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">Issued</div>
                                    </th>
                                </tr>
                            </thead>
                            {/* Table body */}
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    request.requests.map((rqs, key) =>
                                        <tr>
                                            <td className="p-2 pl-4 h-5 text-center">{key + 1}</td>
                                            <td className="p-2 pl-4 h-5">
                                                {rqs.item.name}
                                                { (rqs.discarded || rqs.issued) && <p className="text-gray-500 text-xs italic">{ rqs.discarded ? `Discarded by ${rqs.discardedBy.name}` : rqs.issued ? `Issued by ${rqs.issuedBy.name}` : '' }</p> }
                                            </td>
                                            <td className="p-2 pl-4 h-5">
                                                <span className="flex items-center">
                                                    {rqs.quantity} { pluralize(rqs.item.issuedIn, rqs.quantity) }
                                                </span>
                                            </td>
                                            <td className="p-2 pl-4 h-5">
                                                <span className="flex items-center">
                                                    {rqs.qtyIssued ?? 0 } { pluralize(rqs.item.issuedIn, rqs.qtyIssued ?? 0) }
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        : <div className="align-center flex w-full">
                            <h2>No items have been requested</h2>
                        </div>
                }
            </Receive>
            <div className="flex justify-end">
                <button disabled={loading} onClick={close} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
}

export default SingleItemRequest